export default "__VITE_ASSET__49da5f22__"